import React, { useEffect, useState } from 'react';
import {
    Box,
    Switch,
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    FormControlLabel,
    Alert,
    Pagination
} from '@mui/material';
import { useSelector } from 'react-redux';
import StockService from '../../../../services/StockService';
import notificationService from '../../../../services/notificationService';

const NotificationContentType = {
    NewOrder: 1,
    NewMessage: 2
};

const NotificationDisplayType = {
    New: 1,
    Readed: 2
};

const getContentTypeDescription = (type) => {
    switch (type) {
        case NotificationContentType.NewOrder:
            return "Yeni Sipariş";
        case NotificationContentType.NewMessage:
            return "Yeni Mesaj";
        default:
            return "";
    }
};

const getDisplayTypeDescription = (type) => {
    switch (type) {
        case NotificationDisplayType.New:
            return "Yeni";
        case NotificationDisplayType.Readed:
            return "Okundu";
        default:
            return "";
    }
};

const AllNotification = () => {
    const authUserId = useSelector(state => state?.auth?.user?.id);
    const [notification, setNotification] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPage, setTotalPage] = useState(0);
    const [loading, setLoading] = useState(false);

    const getNotification = async () => {
        try {
            setLoading(true);
            var response = await notificationService.fetchAllNotification(authUserId, page);
       
            setNotification(response?.data);
            setTotalPage(Math.ceil(response.recordsTotal / 10));  
            setLoading(false);
        } catch (exx) {
            setLoading(false);
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    useEffect(() => {
        getNotification();
    }, []);

    useEffect(() => {
        getNotification();
    }, [page]);

    return (
        <Box sx={{
            mt: 5,
            px: 3,
            py: 2,
            backgroundColor: '#f5f5f5',
            borderRadius: 2,
            minHeight: '80vh'
        }}>
            <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box sx={{ width: 4, height: 24, backgroundColor: '#b71c1c', mr: 1 }} />
                        <Typography
                            variant="h6"
                            color="black"
                            sx={{ textTransform: 'uppercase', letterSpacing: '0.08em', mt: 0.5 }}
                        >
                            Bildirimler
                        </Typography>
                    </Box>
                </Box>

                {loading ? (
                    <Typography>Yükleniyor...</Typography>
                ) : notification.length == 0 ? (
                    <Alert severity="info">
                        Bildirim bulunamadı
                    </Alert>
                ) : (
                    <>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} aria-label="stok tablosu">
                                <TableHead>
                                    <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                                        <TableCell>Oluşturma Tarihi</TableCell>
                                        <TableCell>Başlık</TableCell>
                                        <TableCell>Açıklama</TableCell>
                                        <TableCell>Tip</TableCell>
                                        <TableCell>Durum</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {notification.map((n) => (
                                        <TableRow 
                                            key={n.id}
                                            sx={{
                                                opacity: n.displayType === NotificationDisplayType.Readed ? 0.7 : 1,
                                                transition: 'opacity 0.2s'
                                            }}
                                        >
                                            <TableCell>{new Date(n.createDate).toLocaleDateString('tr-TR')}</TableCell>
                                            <TableCell>{n.title}</TableCell>
                                            <TableCell>{n.description}</TableCell>
                                            <TableCell>{getContentTypeDescription(n.contentType)}</TableCell>
                                            <TableCell>{getDisplayTypeDescription(n.displayType)}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, mb: 2 }}>
                                <Pagination
                                    count={totalPage}
                                    page={page}
                                    onChange={handleChangePage}
                                    color="primary"
                                />
                            </Box>
                        </TableContainer>
                    </>
                )}
            </Paper>
        </Box>
    );
};

export default AllNotification;